"use strict";var a=require("../../package.json.js");const e={get:()=>"".concat(a.name,"-").concat(a.version),getMajor:()=>"".concat(a.name,"-").concat(a.version.split(".")[0])};exports.packageDetails=e;
